export default {
  init() {
    let delay = 250
    let timeout = false
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250))
  },
  
  actualResizeHandler() {
    Publish.changeWindowSize({
      width: window.innerWidth,
      height: window.innerHeight
    })
  },

  debounce(func, wait = 250) {
    let timeout
    return function(...args) {
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        func.apply(this, args);
      }, wait);
    };
  }

}


// WEBPACK FOOTER //
// ./src/helpers/modules/pageHandler.js